module dg.objects {

    function multilineText(): ng.IDirective {
        return {
            restrict: 'A',
            template: '<textarea class="form-control noresize"></textarea>',
            replace: true
        };
    }

    angular.module('dg.objects')
        .directive('multilineText', multilineText);
}
